import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { callApi } from 'utils/ApiUtil';
import { Plant, PlantCondition } from 'models/common/Plant';

export const findPlant = async (condition?: PlantCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/common/plant`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<Plant[]> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as Plant[];
};

// 법인, 설비군에 따른 플랜트 조회
export const findPlantForEquipmentGroup = async (condition?: PlantCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/common/findPlantForEquipmentGroup`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<Plant[]> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as Plant[];
};
